import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import {
  DropdownItemComponent,
  DropdownWidth,
  HeaderDefaultComponent,
  IconButtonComponent,
  IconComponent,
  Select2Component,
  Select2Item,
  Select2ListItemDirective,
  Select2TriggerDirective,
} from '@core/user-interface-legacy';
import { dataSource$ } from '@core/views-util';

import { ViewFormService } from '../../view-form.service';

@Component({
  standalone: true,
  selector: 'rt-view-sort',
  templateUrl: './view-sort.component.html',
  styleUrl: './view-sort.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Select2Component,
    Select2TriggerDirective,
    IconComponent,
    HeaderDefaultComponent,
    IconButtonComponent,
    DropdownItemComponent,
    TranslatePipe,
    ReactiveFormsModule,
    Select2ListItemDirective,
  ],
})
export class ViewSortComponent {
  private readonly i18n = inject(I18nService);
  private readonly viewFormService = inject(ViewFormService);
  private readonly dataSource = toSignal(inject(dataSource$), { initialValue: null });

  protected readonly DropdownWidth = DropdownWidth;

  public buttonClass = input('is-first');

  protected sortControl = this.viewFormService.viewForm.controls.sorting;

  protected sortingItems = computed((): Array<Select2Item<string | null>> => {
    const dataSource = this.dataSource();
    if (!dataSource) return [];

    return [
      { label: this.i18n.translate('app.common.none'), value: null },
      ...dataSource.sortings.map(sorting => ({
        label: sorting.name,
        value: sorting.id,
      })),
    ];
  });

  protected toggleSorting(item: Select2Item<string | null>) {
    this.viewFormService.toggleSortingDirection(item.value);
  }
}
